import React from 'react';
import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
} from 'react-native';
import { MARKETPLACE_COLORS } from '@/constants/residents/marketplaceColors';
import { SVG_COMPONENTS } from '@/assets/admin';
import { BaseModal } from './shared';

const WarningIcon = SVG_COMPONENTS.WARNING;

interface ConfirmationModalProps {
  visible: boolean;
  message: string;
  onCancel: () => void;
  onProceed: () => void;
  cancelText?: string;
  proceedText?: string;
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  visible,
  message,
  onCancel,
  onProceed,
  cancelText = 'No, cancel',
  proceedText = 'Proceed',
}) => {
  const footer = (
    <View style={styles.footerButtons}>
      {/* Cancel Button */}
      <TouchableOpacity
        style={styles.cancelButton}
        onPress={onCancel}
        activeOpacity={0.8}
      >
        <Text style={styles.cancelButtonText}>{cancelText}</Text>
      </TouchableOpacity>

      {/* Proceed Button */}
      <TouchableOpacity
        style={styles.proceedButton}
        onPress={onProceed}
        activeOpacity={0.8}
      >
        <Text style={styles.proceedButtonText}>{proceedText}</Text>
      </TouchableOpacity>
    </View>
  );

  return (
    <BaseModal
      visible={visible}
      onClose={onCancel}
      showHeader={true}
      footer={footer}
      size="compact"
    >
      {/* Content */}
      <View style={styles.content}>
        {/* Message Box */}
        <View style={styles.messageBox}>
          {/* Warning Icon */}
          <View style={styles.iconContainer}>
            <WarningIcon width={48} height={48} color={MARKETPLACE_COLORS.textSecondary} />
          </View>
          
          {/* Message Text */}
          <Text style={styles.messageText}>{message}</Text>
        </View>
      </View>
    </BaseModal>
  );
};

const styles = StyleSheet.create({
  content: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  messageBox: {
    paddingHorizontal: 32,
    paddingVertical: 24,
    alignItems: 'center',
    gap: 16,
  },
  iconContainer: {
    width: 48,
    height: 48,
    alignItems: 'center',
    justifyContent: 'center',
  },
  messageText: {
    fontSize: 16,
    fontWeight: '400',
    color: MARKETPLACE_COLORS.textPrimary,
    textAlign: 'center',
    lineHeight: 24,
  },
  footerButtons: {
    flexDirection: 'row',
    gap: 20,
  },
  cancelButton: {
    flex: 1,
    height: 40,
    borderWidth: 1,
    borderColor: MARKETPLACE_COLORS.textPrimary,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
  },
  cancelButtonText: {
    fontSize: 14,
    fontWeight: '500',
    color: MARKETPLACE_COLORS.textPrimary,
    lineHeight: 21,
  },
  proceedButton: {
    flex: 1,
    height: 40,
    backgroundColor: MARKETPLACE_COLORS.accentBlueSolid,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
  },
  proceedButtonText: {
    fontSize: 14,
    fontWeight: '500',
    color: MARKETPLACE_COLORS.textPrimary,
    lineHeight: 21,
  },
});
